/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staff_Resellers_Column_ContactInputs */

const id_staff_resellers_column_contact = /** @type {(inputs: Staff_Resellers_Column_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontak`)
};

const en_staff_resellers_column_contact = /** @type {(inputs: Staff_Resellers_Column_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Staff_Resellers_Column_ContactInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const staff_resellers_column_contact = /** @type {((inputs?: Staff_Resellers_Column_ContactInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staff_Resellers_Column_ContactInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_staff_resellers_column_contact(inputs)
	return id_staff_resellers_column_contact(inputs)
});